import { render, staticRenderFns } from "./UploadRequestFiles.vue?vue&type=template&id=13e142fe"
import script from "./UploadRequestFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadRequestFiles.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports